import React, { Fragment } from "react";
import { withRouter, Link } from "react-router-dom";

const Footer = () => {
    return (
        <Fragment>
            {/* <div id="snackbar" style={snack}></div> */}
            <footer id="footer" className="footerNew">
                <div className="container">
                    <div className="row">
                        <div className="col-sm-6 col-md-2">
                            <div className="wow fadeInUp" data-wow-delay="0.4s">
                                <div className="widget">
                                    <h5>TapTap</h5>
                                    <ul>
                                        <li>
                                            <Link to="/aboutUs">About Us</Link>
                                        </li>
                                        <li>
                                            <Link to="/contact-us">
                                                Contact Us
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/careers">Careers</Link>
                                        </li>
                                        {/* <li>
                      <Link to="/careers">Careers</Link>
                    </li> */}
                                        <li>
                                            <Link to="/companyDetails">
                                                Company Details
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div className="col-sm-6 col-md-2">
                            <div className="wow fadeInUp" data-wow-delay="0.6s">
                                <div className="widget">
                                    <h5>Resources</h5>
                                    <ul>
                                        <li>
                                            <Link to="/privacy-and-policy">
                                                Privacy Policy
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/useragreement">
                                                User Agreement
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/terms-and-condition">
                                                T & C
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/faq">FAQ</Link>
                                        </li>
                                        <li>
                                            <Link to="/blog">Blog</Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div className="col-sm-6 col-md-2">
                            <div className="wow fadeInUp" data-wow-delay="0.8s">
                                <div className="widget">
                                    <h5>Others</h5>
                                    <ul>
                                        <li>
                                            <Link to="/customer">
                                                Join Us as a Customer
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/partners">
                                                Became a Partner
                                            </Link>
                                        </li>
                                        {/* <li>
                      <Link to="/indivisualRegistration">
                        Indivisual Registration{" "}
                      </Link>
                    </li> */}
                                        {/* <li>
                      <Link to="/partnerwithus">Partner WithUs </Link>
                    </li> */}
                                        {/* <li>
                      <Link to="/CustomerRegistration">
                        {" "}
                        Customer Registration{" "}
                      </Link>
                    </li> */}
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div className="col-sm-6 col-md-6">
                            <div className="wow fadeInUp" data-wow-delay="1.0s">
                                <div className="widget">
                                    <img
                                        src="../img/tap8.png"
                                        alt=""
                                        width="120"
                                        height="30"
                                    />
                                    <p style={{ paddingTop: "15px" }}>
                                        Transport management software for
                                        increasing efficiency and effectiveness
                                        by digitizing various business
                                        functions. Additionally Inter-company
                                        transaction management system for
                                        participating stake-holders to expand
                                        our scope and coverage.
                                    </p>
                                    <div style={{border:"0.2px solid transparent",marginTop:"10%"}}>
                                        <h5>Follow us</h5>
                                        <ul className="company-social">
                                            <li className="social-facebook">
                                                <a href="https://www.facebook.com/KabraExpressLogistics">
                                                    <i className="fa fa-facebook"></i>
                                                </a>
                                            </li>
                                            {/* <li className="social-twitter">
                        <a href="https://www.instagram.com/kabra.express/">
                            <i className="fa fa-instagram"></i>
                        </a>
                        </li> */}
                                            <li className="social-twitter">
                                                <a href="https://www.linkedin.com/company/kabra-express-logistics-private-limited/">
                                                    <i className="fa fa-linkedin"></i>
                                                </a>
                                            </li>
                                            <li className="social-youtube">
                                                <a href="https://www.instagram.com/kabra.express/">
                                                    <i className="fa fa-instagram"></i>
                                                </a>
                                            </li>
                                            <li className="social-youtube">
                                                <a href="https://www.youtube.com/channel/UCt4wx_zJAyQ-el--Jy3iurQ">
                                                    <i className="fab fa-youtube"></i>
                                                </a>
                                            </li>

                                            <li className="social-twitter">
                                                <a href="#">
                                                    <i className="fa fa-twitter"></i>
                                                </a>
                                            </li>

                                            {/* <li className="social-google">
                        <a href="#">
                            <i className="fa fa-google-plus"></i>
                        </a> */}
                                            {/* </li> */}
                                            {/* <li className="social-vimeo">
                        <a href="#">
                            <i className="fa fa-vimeo-square"></i>
                        </a>
                        </li> */}
                                            {/* <li className="social-dribble">
                        <a href="#">
                            <i className="fa fa-dribbble"></i>
                        </a>
                        </li> */}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-6 text-center poweredByText">
                            <strong>
                                Powered by{" "}
                                <img src="https://img.icons8.com/bubbles/40/000000/light-on.png" />{" "}
                                Kabra Express Logistics Private Limited
                            </strong>
                        </div>
                    </div>
                </div>
            </footer>

            <a href="#" className="scrollup">
                <i className="fa fa-angle-up active"></i>
            </a>
        </Fragment>
    );
};

export default withRouter(Footer);
